import { checkIfHasBadWordsAndSocialMedia } from "../../../../../../../helpers/et3-text-checker/social-media-and-bad-words";
import { isDefinedString } from "et3-type-guards";

import i18n from "../../../../../../../constants/i18n";
import ET3Div from "../../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../../core/et3-text";
import {
  DESCRIPTION_BODY_FONT_SIZE,
  DESCRIPTION_BODY_HEIGHT,
  DESCRIPTION_BODY_LINE_HEIGHT,
  DESCRIPTION_BODY_PADDING
} from "./descriptions-constants";

const DescriptionBody = withLiteObserverAndTheme<{
  description: string;
  descriptionAlignment: "left" | "right";
}>((props) => {
  const { theme, description, descriptionAlignment } = props;
  const { colors, unitX, unitY } = theme;
  const hasDescription = isDefinedString(description);
  const { hasBadWords, hasSocialMedia } =
    checkIfHasBadWordsAndSocialMedia(description);
  const textColors = hasBadWords
    ? {
        backgroundColor: colors.all.red,
        textColor: colors.all.white
      }
    : hasSocialMedia
      ? {
          backgroundColor: colors.all.orange,
          textColor: colors.all.white
        }
      : {
          backgroundColor: colors.all.transparent,
          textColor: colors.all.maastrichtBlue
        };

  return (
    <ET3Div
      isScrollable={true}
      isExtendable={false}
      fDirection="column"
      justifyContent="flex-start"
      alignItems="stretch"
      withShadow={false}
      width={0}
      height={DESCRIPTION_BODY_HEIGHT}
      color={colors.all.transparent}
      style={{
        boxSizing: "border-box",
        width: "100%",
        padding: `${DESCRIPTION_BODY_PADDING * unitY}px ${
          DESCRIPTION_BODY_PADDING * unitX
        }px`
      }}
      onClick={() => {}}
    >
      <Et3Text
        fontFamily={"LIGHT"}
        fontSize={DESCRIPTION_BODY_FONT_SIZE}
        text={
          hasDescription ? description : i18n.get("NO_DESCRIPTION_SUBMITTED")
        }
        isSpan={false}
        color={hasDescription ? textColors.textColor : colors.all.gray}
        style={{
          margin: 0,
          backgroundColor: textColors.backgroundColor,
          textAlign: hasDescription ? descriptionAlignment : "left",
          overflowWrap: "break-word",
          lineHeight: DESCRIPTION_BODY_LINE_HEIGHT
        }}
      />
    </ET3Div>
  );
});

export default DescriptionBody;
